import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home'
import ArticleList from '@/pages/ArticleList'
import ArticleView from '@/pages/ArticleView'
import Friendlink from '@/pages/Friendlink'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/article',
      name: 'ArticleList',
      component: ArticleList
    },
    {
      path: '/article/:id',
      name: 'ArticleView',
      component: ArticleView
    },
    {
      path: '/friendlink',
      name: 'friendlink',
      component: Friendlink,
    }
  ]
})
